const md5 = require('md5')

import { getEnv } from '@/utils/utils'
import watermarkPng from '@kiss/pages/shareComicPage/assets/watermark.png'

/**
 * 对象转换
 * @param params
 * @returns
 */
export const converUrlParamsObj = (params: Record<string, any>): string => {
  const _result = []
  const isFalse = (value: any) => value === undefined || value === null
  for (const key in params) {
    const value = params[key]
    if (value?.constructor === Array) {
      value.forEach((_value: any) => {
        _result.push(key + '=' + _value)
      })
    } else {
      !isFalse(value) && _result.push(key + '=' + value)
    }
  }
  return _result.join('&')
}

/**
 * 地址栏参数解析
 * @returns
 */

export const getSearchData = (search: string): any => {
  if (!search) return {}
  const searchArr = search.split('?')[1].split('&')
  const obj: any = {}
  searchArr.forEach((item) => {
    const arr = item.split('=')
    obj[arr[0]] = arr[1]
  })
  return obj
}

// 设备检测
/* eslint  no-cond-assign:0 radix:0 */
export const getUA = (): Record<string, boolean> => {
  const UA: any = {}
  const ua = navigator.userAgent.toLowerCase()
  let s
  UA.ie = (s = ua.match(/(msie\s|trident.*rv:)([\d.]+)/))
    ? parseInt(s[2])
    : false
  UA.firefox = (s = ua.match(/firefox\/([\d.]+)/)) ? parseInt(s[1]) : false
  UA.chrome = (s = ua.match(/chrome\/([\d.]+)/)) ? parseInt(s[1]) : false
  UA.opera = (s = ua.match(/opera.([\d.]+)/)) ? parseInt(s[1]) : false
  UA.safari = (s = ua.match(/version\/([\d.]+).*safari/))
    ? parseInt(s[1])
    : false
  UA.android = (s = ua.match(/android/)) ? s : false
  UA.iphone = (s = ua.match(/iphone os/)) ? s : false
  UA.ipad = (s = ua.match(/ipad/)) ? s : false
  // ipad中  ios13之后，navigator.userAgent不包含ipad字段
  UA.ipad13 = (s = ua.match(/mac/) && navigator.maxTouchPoints > 1)
    ? { s }
    : false
  UA.ios = UA.ipad || UA.iphone || UA.ipad13
  UA.isWin32 = /win32/i.test(window.navigator.platform)
  UA.isWeixin = (s = ua.match(/MicroMessenger/i)) ? !!s : false // 判断是否是在微信浏览器里面
  UA.isUcweb = (s = ua.match(/ucbrowser/)) ? !!s : false
  UA.isMqq = (s = ua.match(/mqqbrowser/)) ? !!s : false // 是否是手机qq浏览器
  UA.isWeiBo = (s = ua.match(/__weibo__/)) ? !!s : false // 是否微博浏览器
  // console.log(UA);

  UA.isMobile = UA.android || UA.ios
  return UA
}

/** 活动页使用kiss h5的deeplink */
export const deepLink = (
  book_id: string,
  pushType: 0 | 1 | 2 | 3 = 3,
  contentType?: number
): string => {
  if (!book_id) {
    console.log('没有book_id参数')
    return ''
  }

  // 分享h5追踪码
  const t_ios = 'pyxo2mp'
  const t_android = 'd4yitmp'
  const adj_t_h5: string = getUA().ios ? t_ios : t_android
  const actionParams = JSON.stringify({ book_id: book_id, c_id: '1', c_idx: 1 })
  const af_web_dp = encodeURIComponent(`https://5yxe.adj.st/?adj_t=${adj_t_h5}`)
  const deepLink = encodeURIComponent(
    `cmskiss://?${converUrlParamsObj({
      type: 2001,
      actionParams,
      pushType: pushType,
      contentType: contentType || 1
    })}`
  )
  const link = `https://kissapp.onelink.me/6Vxq?pid=test&c=CMS_APP_EXCHANGE&af_web_dp=${af_web_dp}&af_dp=${encodeURIComponent(
    `cmskiss://`
  )}&deep_link_value=${deepLink}`
  return link
}

export const watermark = ({
  src,
  className
}: {
  src: string
  className: string
}): void => {
  console.log(src, '--------')

  // 创建canvas进行绘图
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const img = new Image()
  img.crossOrigin = 'anonymous'
  // img.setAttribute('crossOrigin', 'anonymous');
  img.src = src
  img.onload = function () {
    // 图片的清晰度 有关压缩
    const quality = 1
    canvas.width = img.width
    canvas.height = img.height

    // 设置水印的宽高
    const markImgH = 50
    const markImgW = 30
    // 首先绘制需要上传至服务器的图

    ctx?.drawImage?.(img, 0, 0, canvas.width, canvas.height)
    // 将水印绘制上去，位置在右下角
    const img2 = new Image()
    img2.src = watermarkPng
    ctx?.drawImage?.(img2, img.width, img.height)
    // //@ts-ignore
    // ctx.fillStyle = "red";
    // //@ts-ignore
    // ctx.textBaseline = "middle";
    // //@ts-ignore
    // ctx.fillText('watermarkText', 20, 20);

    // 转为base64格式
    // let newSrc = canvas.toDataURL('image/png')

    const image = new Image()
    image.src = canvas.toDataURL('image/png')
    document.querySelector(className)?.appendChild?.(image)
    // 转为file对象传递出去
    // callback(dataURLtoFile(imgData, file.name))
  }

  // return newSrc
}

// 将base64转换为文件
function dataURLtoFile(dataurl: string, filename: string) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

/** 处理登录时MD5加密参数 */
interface IMd5 {
  clientToken: string
  time: number
}
/** 获取md5加密后的sign，加密规则看kissshoudow的内嵌H5登录文档 */
export const handleH5LoadingMD5 = (props: IMd5): string => {
  const { clientToken = '', time = 0 } = props
  const sign = md5(
    md5(`${clientToken}${clientToken.split('').reverse().join('')}${time}`)
      .split('')
      .reverse()
      .join('')
  )

  return sign
}
// 获取组装后的token
export const getToken = (): string =>
  localStorage.getItem('token')?.indexOf('Bearer') === -1
    ? `Bearer ${localStorage.getItem('token')}`
    : localStorage.getItem('token') || ''

/** 获取用户id */
export const getUid = (): string => localStorage.getItem('uid') || ''

/** 判断是否FB内置浏览器 */
export const isFBWeb = (): boolean => {
  const uAgent = navigator.userAgent
  return (
    uAgent.indexOf('FB_I') > -1 ||
    uAgent.indexOf('FBAV') > -1 ||
    uAgent.indexOf('FBAN') > -1 ||
    uAgent.indexOf('FBIOS') > -1
  )
}

export const getLang = (): string => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const systemLanguage = navigator.language || navigator?.userLanguage
  // console.log('systemLanguage', systemLanguage)
  const [prefix, suffix] = (systemLanguage || 'en-US').split('-')
  let systemLang = prefix
  if (['TW', 'HK', 'MO', 'tw', 'hk', 'mo'].includes(suffix)) {
    systemLang = 'tw'
  }

  const queryData = new URLSearchParams(location.href.split('?')[1]) || ''
  const queryLang = decodeURIComponent(queryData.get('lang') || '')

  const localLang = localStorage.getItem('lang')
  if (localLang === 'in') return 'id'

  return localLang || systemLang || queryLang || 'en'
}

export function parseQueryString(queryString: string): Record<string, string> {
  const params: any = {}
  if (queryString) {
    const keyValues = queryString.slice(1).split('&')
    keyValues.forEach(function (keyValue) {
      const pair = keyValue.split('=')
      const key = decodeURIComponent(pair[0])
      const value = decodeURIComponent(pair[1] || '')
      if (key.length > 0 && params[key] === undefined) {
        params[key] = value
      }
    })
  }

  return params
}

/** 兼容一下以前的链接 */
export function getPageQuery(): Record<string, string> {
  let search = ''
  if (location.hash) {
    search = location.hash.replace('#/', '')
  } else {
    search = location.search
  }
  return parseQueryString(search)
}

enum Enetwork {
  'no-network' = 0,
  'wifi' = 1,
  'unknown' = 200,
  '2g' = 202,
  '3g' = 203,
  '4g' = 204,
  '5g' = 205
}
// 获取网络类型
export const getNetworkType = (): Enetwork => {
  const nav = window.navigator as any
  const nonetwork =
    nav?.connection?.downlink === 0 && nav?.connection?.rtt === 0
  const networkStr = nonetwork
    ? 'no-network'
    : nav?.connection?.effectiveType || ''
  let networkType
  switch (networkStr) {
    case 'wifi':
      networkType = Enetwork.wifi
      break
    case '4g':
      networkType = Enetwork['4g']
      break
    case '3g':
      networkType = Enetwork['3g']
      break
    case '3gnet':
      networkType = Enetwork['3g']
      break
    case '2g':
      networkType = Enetwork['2g']
      break
    case 'no-network':
      networkType = Enetwork['no-network']
      break
    default:
      networkType = Enetwork.unknown
  }
  return networkType
}

const feedbackUrl = {
  dev: 'https://dev-h5.stardustworld.cn/feedback/allfb/#/',
  development: 'https://dev-h5.stardustworld.cn/feedback/allfb/#/',
  test: 'https://dev-h5.stardustworld.cn/feedback/allfb/#/',
  gray: 'https://feedback.crazymaplestudios.com/feedback/allfb/#/',
  prod: 'https://feedback.crazymaplestudios.com/feedback/allfb/#/'
}
/** 获取feedback链接 */
export const getFeedbackUrl = (): string => {
  const baseUrl = feedbackUrl[getEnv()] || feedbackUrl['prod']

  const networkType = getNetworkType()
  const params: {
    [key: string]: any
  } = {
    appid: 'cm1003',
    channel: localStorage.getItem('channelId') || '',
    language: localStorage.getItem('lang') || 'en',
    from: 'feedback',
    devicePlatform: 'devicePlatform',
    uuid:
      [1, 2, 3, 4].reduce((p) => p + Math.floor(Math.random() * 10), '') +
      localStorage.getItem('uid'),
    deviceName: localStorage.getItem('devModel') || 'deviceName',
    // todo 更改 package.json的version时，记得同步更改这里
    version: localStorage.getItem('clientVer') || 'V1.0.0',
    did: localStorage.getItem('devId') || 'did',
    network: networkType,

    // 最后一个字段，有新增字段放这上边
    'package-name': 'paypal_h5'
  }

  const deviceMatchArr = navigator.userAgent.match(/\([^\)]+\)/gi)
  // 系统、设备信息字符数组
  let deviceInfoArr: string[] = []
  if (deviceMatchArr && deviceMatchArr?.length > 0) {
    deviceInfoArr = deviceMatchArr[0].replace(/(\(|\))/gi, '')?.split(';')
  }
  if (deviceInfoArr?.length > 0) {
    deviceInfoArr = deviceInfoArr.map((i) => i.trim().replace(/\s+/gi, '_'))
  }
  if (deviceInfoArr?.length === 3) {
    if (deviceInfoArr[0].match(/windows/gi)) {
      params.devicePlatform = deviceInfoArr[0]
      params.deviceName = deviceInfoArr[1]
    } else {
      params.devicePlatform = deviceInfoArr[1]
      params.deviceName = deviceInfoArr[2]
    }
  } else if (deviceInfoArr?.length === 2) {
    params.devicePlatform = deviceInfoArr[1]
    params.deviceName = deviceInfoArr[0]
  }

  let paramsStr = ''
  for (const key in params) {
    if (key === 'package-name') {
      paramsStr += `${key}=${params[key]}`
    } else {
      paramsStr += `${key}=${params[key]}&`
    }
  }

  const link = `${baseUrl}?${paramsStr}`
  return link
}

// 获取时区偏移量
export const getTimeZoneOffset = (): string => {
  const offset = new Date().getTimezoneOffset()
  // offset 是本地时区与 UTC 的差值，单位是分钟，西区为正，东区为负
  const hours = Math.floor(Math.abs(offset) / 60) // 计算小时部分
  const minutes = Math.abs(offset) % 60 // 计算分钟部分

  // 格式化成 -8:00 或 +5:30 等形式
  const sign = offset > 0 ? '-' : '+'
  return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0'
  )}`
}
